

(function( ){


	//------------------------------------------------------------------------------------------------------------------------------


		var Main = function( )
		{
			var _this = this , i ;
			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


			// hover touchのイベント
			// タブレット時(表示PC)にSNSリンクから戻った際に、:hoverがそのままになるので
			// jsでの処理に変更。クラスを外すイベントにclickも入れる
			var touchTarget = [
				'a',
				'.js-over',
				'.charactor-thumb-list li',
				'.close-button',
				'.cm-list-button li'
			];

			function touchAddClass(touchTarget) {
				for ( var i = 0; i < touchTarget.length; i++) {
					$(document).on('touchstart mouseenter', touchTarget[i], function(e) {
						$(e.currentTarget).addClass('is-over');
					});
					$(document).on('touchend mouseleave click',touchTarget[i], function(e){
						$(e.currentTarget).removeClass('is-over');
					});
				}
			}
			$(window).on('load', function() {
				touchAddClass(touchTarget);
			});


			// 読込が超重いので、スライダーなどの読込を遅延
			// classをつけてCSSで
			var lazyImageTarget = document.getElementsByClassName('lazyTarget');
			var lazyImageAddclass = function(target){
				for ( var i = 0; i < target.length ; i++ ){
					target[i].className = target[i].className + ' loaded' ;
				}
			}
			$(window).on('load',function(){
				lazyImageAddclass(lazyImageTarget);
			});


			// ----------------------------------------------
			// modal
			// ----------------------------------------------
			var modalClose = function( e ){
				document.body.style.overflow = '';
				var target = e.currentTarget.getAttribute('data-modal-close');
				var $targetDom = $('#'+target);
				$targetDom.fadeOut();
			};

			var modalOpen = function( e ){
				document.body.style.overflow = 'hidden';
				var target = e.currentTarget.getAttribute('data-target-modalId');
				var $targetDom = $('#'+target);
				$targetDom.fadeIn();

				var closeButton = $targetDom.find('.close-button');
				closeButton[0].addEventListener('click',modalClose);



			};

			var modalButton = document.getElementsByClassName('modalOpen');
			for( var i = 0 ; i < modalButton.length ; i++){
				modalButton[i].addEventListener('click',modalOpen);
			};


			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

			// ----------------------------------------------
			// kv アニメーション クラスつけるだけ
			// ----------------------------------------------
			var addClass = function(target,delay){
				setTimeout(function(){
					target.addClass('is_show');
				},delay+500);
			};


			$(window).on('load',function(){
				addClass($('#asuna'),100);
				addClass($('#kirito'),500);


				addClass($('#chara03'),800);
				addClass($('#chara04'),1000);
				addClass($('#chara05'),1200);
				addClass($('#chara06'),1400);

				addClass($('#bgChara'),1800);

				addClass($('#kvLogo'),2000);
				addClass($('.modal-button'),2000);
				addClass($('.kv_bottom'),2000);

			});


			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


			// ----------------------------------------------
			// meter
			// ----------------------------------------------
			// jsonをajaxして、そのデータをもとに描画
			// 数値は0-100、整数じゃなくても良い。
			var metorJsonUrl = '/upload/promo-sao-meter.json';


			var getNumeric = function(data,num){
				return Math.floor(data / num % 10);
			};
			var graphAnimation = function(data){
				var canvas = document.getElementById('graph');

				var graphA = data,
						graphB = 100 - data;
				var ctx = canvas.getContext('2d');


				var draw = Chart.controllers.doughnut.prototype.draw;
				Chart.controllers.doughnut = Chart.controllers.doughnut.extend({
					draw: function() {
						draw.apply(this, arguments);
						var ctx = this.chart.chart.ctx;
						var _fill = ctx.fill;
						ctx.fill = function() {
								ctx.save();
								ctx.shadowColor = '#65f4ff';
								ctx.shadowBlur = 8;
								ctx.shadowOffsetX = 0;
								ctx.shadowOffsetY = 0;
								_fill.apply(this, arguments);
								ctx.restore();
						};
					}
				});

				var data = {
					datasets: [{
							data: [graphA,graphB],
							backgroundColor:[
								'#83f6ff',
								'transparent'
							],
							borderWidth: 0,
					}],
				};

				var animated = false;
				var achieved25 = false,
						achieved50 = false,
						achieved75 = false,
						achieved100 = false;

				var target_one = document.getElementById('num_one'),
						target_ten = document.getElementById('num_ten'),
						target_hundred = document.getElementById('num_hundred');

				var num_oneB = 0,
						num_tenB = 0,
						num_hundredB = 0;
				var graph = new Chart(ctx,{
					type: 'doughnut',
					data: data,
					responsive: false,

					options: {
						cutoutPercentage: 63,
						animation: {
							duration: 3000,
							easing: 'linear',
							onProgress: function(animation) {
								if(animated) return;
								var progress = animation.animationObject.currentStep / animation.animationObject.numSteps * graphA;
								if(progress >= 25 && !achieved25){
									achieved25 = true;
									$('#item25').addClass('achieved');
								}
								if(progress >= 50 && !achieved50){
									achieved50 = true;
									$('#item50').addClass('achieved');
								}
								if(progress >= 75 && !achieved75){
									achieved75 = true;
									$('#item75').addClass('achieved');
								}
								if(progress >= 100 && !achieved100){
									achieved100 = true;
									$('#item100').addClass('achieved');
								}

								var floorProgress = Math.floor(progress);
								var num_one = getNumeric(floorProgress, 1);

								if(num_oneB != num_one){
									target_one.className = 'num_'+num_one;
									num_oneB = num_one;

								}

								if(floorProgress >= 10){
									var num_ten = getNumeric(floorProgress, 10);
									target_ten.className = 'num_'+num_ten;
								}
								if(floorProgress >= 100){
									var num_hundred = getNumeric(floorProgress, 100);
									target_hundred.className = 'num_'+num_hundred;
								}
							},
							onComplete: function(){
								animated = true;
							}
						},
						tooltips: {
							enabled : false,
						},
						hover: {
							mode : null
						},
					}
				});
				graph.stop();


				ScrollEnterEvent.add(document.getElementById('graph'),{
					onEnter: function() {
						graph.render();
					},
					marginScale: 0.5
				});

			};

			$(window).on('load',function(){
				var image = [
					"./assets/index/img/common/meter/num_0.png",
					"./assets/index/img/common/meter/num_1.png",
					"./assets/index/img/common/meter/num_2.png",
					"./assets/index/img/common/meter/num_3.png",
					"./assets/index/img/common/meter/num_4.png",
					"./assets/index/img/common/meter/num_5.png",
					"./assets/index/img/common/meter/num_6.png",
					"./assets/index/img/common/meter/num_7.png",
					"./assets/index/img/common/meter/num_8.png",
					"./assets/index/img/common/meter/num_9.png",
				];
				Utils.Image.load.object( image , function(){
					$.ajax({
						url : metorJsonUrl,
						type : 'GET',
						dataType : 'json',
						cache : false,
					})
					.done( function(json){
						var meterData = json.data;

						if( meterData > 100 ) meterData = 100;
						if( meterData < 0 )   meterData = 0;

						graphAnimation(meterData);
					});
				} , false , true );

			});

			//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

			// ----------------------------------------------
			// slider
			// ----------------------------------------------
			var slider_is_active = false;
			var sliderSettings = {
				'1' : { // キリト
					'text' : '死のゲームと化した《SAO》で戦い続けるソロプレイヤー。女性のような顔立ちと線の細いシルエットだが、戦いの腕は《SAO》でもトップクラス。',
					'get' : 'ガチャ「ソードアート・オンライン」でGET',
					'length' : 3,
					'ytb': '58VNDpcchrs'
				},
				'2' : { // アスナ
					'text' : '《SAO》屈指のギルド《血盟騎士団》の副団長を務める少女。<br>その華麗な剣技から《閃光》の異名を持つ。物腰は優しいが、芯は強い。',
					'get' : 'ガチャ「ソードアート・オンライン」でGET',
					'length' : 2,
					'ytb': '1UfrYcsKUec'
				},
				'3' : { // シノン
					'text' : '銃と鋼鉄のMMO≪ガンゲイル・オンライン(GGO)≫プレイヤーの少女。<br>長大なライフル≪ヘカートⅡ≫を愛用する狙撃手。',
					'get' : 'ガチャ「ソードアート・オンライン」でGET',
					'length' : 2,
					'ytb': 'KpSU-jGkesE'
				},
				'4' : { // リーファ
					'text' : '敏捷性と剣技に長けたシルフのプレイヤー。<br>《アルヴヘイム・オンライン》の世界に不慣れなキリトの案内役を務めることに。',
					'get' : 'ガチャ「ソードアート・オンライン」でGET',
					'length' : 2,
					'ytb': 'KpSU-jGkesE'
				},
				'5' : { // シリカ＆リズベット
					'text' : 'シリカ：使い魔《フェザーリドラ》のピナを従える《ビーストテイマー》の少女。<br>《SAO》のアイドル的存在となっている。<br>リズベット：《アインクラッド》で武具店（鍛冶屋）を営む少女。<br>アスナの親友。愛称はリズ。',
					'get' : 'ガチャ「ソードアート・オンライン」でGET',
					'length' : 2,
					'ytb': '1UfrYcsKUec'
				},
				'6' : { // ユウキ
					'text' : 'その脅威的な剣の冴えから、《絶剣》と呼ばれている謎のアバター。<br>アスナとの決闘（デュエル）後、自分のギルドにアスナを勧誘する。',
					'get' : 'クエスト「絶剣」でGET',
					'length' : 2,
					'ytb': '_SvsqxFaDDQ'
				},
				'7' : { // ヒースクリフ
					'text' : '《SAO》最強と名高いギルド《血盟騎士団》の創設者。落ち着いた大人の男性で、厳しい反面、自ら危険な最前線に立つ。防御やカウンター重視のユニークスキル《神聖剣》を習得し、片手剣＋大きな盾を装備した鉄壁のスタイルは、副団長のアスナも「HPゲージが半分を切ったのを見たことがない」と畏怖するほど。',
					'get' : 'クエスト「解放の日」でGET',
					'length' : 2,
					'ytb': 'Aps2DjRIXtk'
				},
				'8' : { // ユージーン
					'text' : 'サラマンダー領主・モーティマーと現実世界でも兄弟で、《ALO》最強を自負している将軍。伝説級武器の《魔剣グラム》を所有し、キリトとも互角の空中戦を繰り広げる強さを持つ。',
					'get' : 'クエスト「猛炎の将」でGET',
					'length' : 2,
					'ytb': 'Aps2DjRIXtk'
				},
				'9' : { // デスガン
					'text' : '謎多き《GGO》のアバター。ゲーム内で有名なプレイヤーを銃撃し、現実世界でも死に至らしめている。《SAO》時代のキリトと因縁があるが、当時のアバターネームを明かすことはなく、その正体を隠している。',
					'get' : 'クエスト「死の追撃者」でGET',
					'length' : 2,
					'ytb': '_SvsqxFaDDQ'
				},
				'10' : { // オベイロン
					'text' : '総合電子機器メーカー・レクトの社員にして、《アルヴヘイム・オンライン》のゲームマスター。アスナなど旧《SAO》プレイヤーの意識を閉じ込め、思考操作の人体実験を行っていた。',
					'get' : 'クエスト「鍍金の勇者」でGET',
					'length' : 2,
					'ytb': null
				},
				'11' : { // クラディール
					'text' : '《血盟騎士団》のメンバーでアスナの護衛だったが、彼女に心酔するあまり、目障りなキリトにデュエルを挑むなど過激な行動が目立ち、護衛役を解任されてしまう。',
					'get' : 'クエスト「紅の殺意」でGET',
					'length' : 2,
					'ytb': null
				},
				'12' : { // アリス
					'text' : '《アンダーワールド》でのキリトとユージオの幼馴染。ルーリッド村の村長の娘で神聖術を得意とする少女。',
					'get' : 'キャンペーン「黒のモンスト剣士 井上キリトを応援しよう！」でGET',
					'length' : 1,
					'ytb': null
				},
				'13' : { // アスナ&キリト
					'text' : '「モンスト×電撃25周年」コラボのキャラクター「アスナ＆キリト」が再登場！<br><br>キリト：死のゲームと化した《SAO》で戦い続けるソロプレイヤー。女性のような顔立ちと線の細いシルエットだが、戦いの腕は《SAO》でもトップクラス。<br><br>アスナ：《SAO》屈指のギルド《血盟騎士団》の副団長を務める少女。その華麗な剣技から《閃光》の異名を持つ。物腰は優しいが、芯は強い。',
					'get' : 'コラボ限定スペシャルミッション等でGET',
					'length' : 2,
					'ytb': null
				},

			};
			$(window).on('load',function(){
				$('[data-charaNumber="1"],[data-charaNumber="6"]').addClass('bg-dark');
				$('[data-charaNumber="2"],[data-charaNumber="11"]').addClass('bg-water');
				$('[data-charaNumber="3"],[data-charaNumber="7"],[data-charaNumber="12"],[data-charaNumber="13"]').addClass('bg-light');
				$('[data-charaNumber="4"],[data-charaNumber="10"],[data-charaNumber="9"]').addClass('bg-wood');
				$('[data-charaNumber="5"],[data-charaNumber="8"]').addClass('bg-fire');
			});


			// main
			var $slider = $('#charaSlider').slick({
				arrows: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				autoplay: false,
				// fade: true,
				// autoplaySpeed: 4000,
				swipe: true,
				asNavFor: '#nameSlider',
				speed: 300,
				initialSlide: 1,
			});

			// name
			var $nameSlider = $('#nameSlider').slick({
				arrows: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				autoplay: false,
				fade: true,
				speed: 100,
				// autoplaySpeed: 4000,
				swipe: false,
				asNavFor: '#charaSlider',
				initialSlide: 1,
			});

			// prev-button
			var prevButton = $('#sliderPrev');
			prevButton.on('click', function(){
				if(slider_is_active) return;
				$slider.slick('slickPrev');
			});

			// next-button
			var nextButton = $('#sliderNext');
			nextButton.on('click', function(){
				if(slider_is_active) return;
				$slider.slick('slickNext');
			});


			//event
			function checkButton(length,type){
				var buttonTypes = {
					// 0 = 前の人, 1 = 進化前, 2 = 進化後,
					prev : '',
					// 0 =　次の人, 1 = 進化後, 2 = 神化後
					next : ''
				};

				if(type == 1){
					buttonTypes.prev = 0;
					if(length - type == 0){
						buttonTypes.next = 0;
					}else{
						buttonTypes.next = 1;
					}
				}
				if(type == 2){
					buttonTypes.prev = 1;
					if(length - type == 0){
						buttonTypes.next = 0;
					}else{
						buttonTypes.next = 2;
					}
				}
				if(type == 3){
					buttonTypes.prev = 2;
					buttonTypes.next = 0;
				}

				return buttonTypes;
			}
			$slider.on('beforeChange',function(event, slick, currentSlide, nextSlide){
				slider_is_active = true;
				var nextSlideObj = slick.$slides[nextSlide];
				var currentSlideObj = slick.$slides[currentSlide];
				var nextCharaNumber = $(nextSlideObj).attr('data-charaNumber');
				var nextCharaType = $(nextSlideObj).attr('data-chara-type');

				var currentCharaNumber = $(currentSlideObj).attr('data-charaNumber');

				//ボタンの変更
				var buttonTypes = checkButton(sliderSettings[nextCharaNumber]['length'],nextCharaType);
				nextButton.removeClass('buttonType0 buttonType1 buttonType2');
				nextButton.addClass('buttonType'+buttonTypes.next);

				prevButton.removeClass('buttonType0 buttonType1 buttonType2');
				prevButton.addClass('buttonType'+buttonTypes.prev);



				// キャラが変わった時
				if(nextCharaNumber != currentCharaNumber){

					//textの変更
					var descripntionText = sliderSettings[nextCharaNumber]['text'];
					var getText = sliderSettings[nextCharaNumber]['get'];
					$('#charaText span').fadeTo(100,0,function(){
						$(this).html(descripntionText);
					});
					$('#charaGetText .text').fadeTo(100,0,function(){
						$(this).html(getText);
					});

					// thumbのactive変更
					$('#thumbList li').removeClass('is_active');
					$('#thumbList li[data-slickNumber="'+nextCharaNumber+'"]').addClass('is_active');

					//使ってみた動画
					var movieId = sliderSettings[nextCharaNumber]['ytb'];

					var movieWrap = $('#movieWrap');
					// if(movieId == null)
					movieWrap.fadeOut(100,function(){
						$('#movieWrap .movie-thumb').attr('src','');
					});
				}

			});
			$slider.on('afterChange',function(event, slick, currentSlide, nextSlide){
				slider_is_active = false;
				$('#charaText span').fadeTo(50,1);
				$('#charaGetText .text').fadeTo(50,1);

				var currentSlideObj = slick.$slides[currentSlide];
				var currentCharaNumber = $(currentSlideObj).attr('data-charaNumber');
				var movieId = sliderSettings[currentCharaNumber]['ytb'];

				if(movieId){
					var tragetTag = $('#movieWrap .js-YT-video-modal');
					var targetImage = $('#movieWrap .movie-thumb');

					tragetTag.attr('data-yt-video-id',movieId);
					tragetTag.attr('href','https://youtu.be/'+movieId);
					tragetTag.attr('data-tracking','movie-char,view,https://youtu.be/'+movieId);

					targetImage.attr('src','https://img.youtube.com/vi/'+movieId+'/maxresdefault.jpg')

					$('#movieWrap').fadeIn(100);
				}

			});

			// thumbnailリスト
			function thumbClik(target){
				var charaNumber = $(target).attr('data-slickNumber');
				var SelectSlickNumber;

				//slickからキャラの最初を探す
				var $sliderList = $slider[0].slick.$slides;
				for (var i = 0 ; i < $sliderList.length ; i++ )
				{
					var dataNum = $($sliderList[i]).attr('data-charaNumber');
					var dataType = $($sliderList[i]).attr('data-chara-type');
					if(dataNum == charaNumber){
						// キャラ番号とマッチした最初のslick currentを入れる。
						SelectSlickNumber = $($sliderList[i]).attr('data-slick-index');
						if(dataType == 2){

							// キャラ番号2=進化後があった場合上書き（進化後がないキャラクターがいるため）
							SelectSlickNumber = $($sliderList[i]).attr('data-slick-index');
							break;
						}
					}
				}
				$slider.slick('slickGoTo',SelectSlickNumber);

				if( Fit.mode == 'sp' )
				{
					var target = document.getElementById('charaName');
					AnchorScroll.to(target);
				}

			}
			$('#slider').on('click','#thumbList li',function(e){
				thumbClik(this);
			});

			// spとPCでサムネイルの位置を変更
			var thumb = $('#thumbList');
			var typeCeck = false;
			var thumbPositionChange = function(){
				if(typeCeck == ($(window).width() < 737)) return;

				typeCeck = ($(window).width() < 737);
				if($(window).width() < 737)
				{
					thumb.remove();
					$('#slider').append(thumb);
				}else{
					$('#slider').prepend(thumb);
				}
			};
			$(window).on('load resize',function(){
				// thumbPositionChange();
			});



			//cmのスライダー追加
			$cmSlider = $('#cmSlider').slick({
				arrows: false,
				pauseOnHover: false,
				pauseOnFocus: false,
				autoplay: false,
				swipe: true,
				speed: 300,
				initialSlide: 0,
				dots: true,
				dotsClass: 'slider-dots'
			});

			var cmSliderIsSliding = false;
			$cmSlider.on('beforeChange', function() {
				cmSliderIsSliding = true;
			});

			$cmSlider.on('afterChange', function() {
				cmSliderIsSliding = false;
			});

			//cmスライダーのボタンクリック
			function cmListClick(e){
				var clickTarget = $(e.target);

				if(clickTarget.closest('#cmSlider li')[0]){
					if(cmSliderIsSliding){
						e.stopPropagation();
						e.preventDefault();
					}
				}
			}
			window.addEventListener('click',cmListClick,true);




			//cmスライダーのボタンクリック
			$('#cmListButton li').on('click',function(){
				var targetSlider = parseInt($(this).attr('data-cm-number'));
				$cmSlider.slick('slickGoTo',targetSlider);
			});

		};


		$(window).on('load',function(){
			//IEのFirefoxで読み込み時にFitがうまく効かないので記述。
			setTimeout(function(){
				FitContents.fit();
			},500);
		});


	//------------------------------------------------------------------------------------------------------------------------------


		window.requestAnimationFrame = 	window.requestAnimationFrame ||
										window.webkitRequestAnimationFrame ||
										function( func ){ return setTimeout( func , 1000/60 ) ; } ;


		window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
										window.webkitCancelAnimationFrame ||
										function( id ){ clearTimeout( id ) ; } ;


		document.readyState === "complete"
			? setTimeout( function(){ new Main( ) ; } , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


	//-----------------------------------------------------------------------------------------------------------------------------


} )( ) ;





